import React, { Fragment }  from "react";
import Header from "../Header/Header";
import "../About/About.css";
import About1 from "../../../img/about2.png";
import About2 from "../../../img/about3.png";
import Trusted3 from "../../../img/Trusted3.png";
import Trusted2 from "../../../img/Trusted2.png";
import Trusted4 from "../../../img/Trusted1.png";
import Trusted1 from "../../../img/Trusted4.png";
import { Helmet } from 'react-helmet-async';
import Footer from "../Footer/Footer";

export default function About() {
  return (
    <>
      <Fragment>

      <Helmet>
      <title>About Us | Best Hearing Aids In Singapore | The Hearing Centre</title>
        <meta name="description" content="The Hearing Centre provides quality hearing aids and is a world-class provider of hearing services in Singapore for the last 16 years." />
        <meta property="og:title" content="About Us | Best Hearing Aids In Singapore | The Hearing Centre"></meta>
        <meta property="og:description" content="The Hearing Centre provides quality hearing aids and is a world-class provider of hearing services in Singapore for the last 16 years."></meta>
    </Helmet>
      <Header />
      <section className="hearing_service About_img">
        <div className="container">
          <h1 className="Heading_text">About Us</h1>
        </div>
      </section>
      <section className="About_text">
        <div className="container">
          <div className="row  gap-3 gap-lg-0 ">
            <div className="col-lg-6">
              <div className="about_img text-center text-lg-start">
                <img src={About1} className="img-fluid" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about_img">
                <h5>Our History</h5>
                <h1>
                  Our Journey : Becoming Your Trusted Hearing Aids Provider in
                  Singapore
                </h1>
                <p>
                  The Hearing Centre Singapore is a world-class provider of
                  hearing aids and hearing care services in Singapore for the
                  last 18 years, with a vision to be the trusted leader in
                  cost-effective and provider of quality hearing aids and
                  hearing solutions in Singapore and beyond.
                </p>

                <p>
                  With a strong suit in hearing healthcare for almost two
                  decades, The Hearing Centre Singapore recognizes all the
                  existing distress, fear and worries that dwells in people who
                  tend to suffer hearing loss themselves, or for their loved
                  ones. Right from consultation, diagnosis and counselling to
                  various assessments, fittings of hearing aids to post-fitting
                  care and support. We nurture every situation with excellence
                  in expertise and care beyond measure.
                </p>

                <p>
                  The facility’s talented and well-experienced team encompasses
                  every hearing subspecialty right from hearing knowledge,
                  research, diagnostics and therapies which have revolutionized
                  various diseases and disorders and is driving the
                  organization’s mission to be the leader in the hearing
                  industry with the most advanced technology and solutions in
                  collaboration with ENT specialists.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="About_text">
        <div className="container">
          <div className="row flex-column-reverse flex-lg-row gap-3 gap-lg-0">
            <div className="col-lg-6">
              <div className="about_img">
                {/* <h5>Our History</h5> */}
                <h1>About The Hearing Centre</h1>
                <p>
                  There are many reasons for The Hearing Centre’s success,
                  including the values of honesty, integrity and commitment to
                  the customers and folklore of personalized caregiving and
                  optimum addressing to the most complex types of cases. Another
                  reason is that we understand the utmost importance of
                  “hearing” as an individual and we make our patients a part of
                  our extended family, and not just providing care as a duty of
                  a service provider. Therefore, our focus is providing value
                  more than money.
                </p>

                <p>
                  Having our Audiometric Room, state-of-the-art equipment and
                  strong ties with manufacturers, we are able to offer our
                  hearing aid services at an affordable cost. Our optimized
                  business model provides patients with the best hearing aid
                  products at the most affordable prices. Today, this vow of
                  affordable hearing aids and hearing care services at fair
                  price-to-value ratio still stands in The Hearing Centre
                  Singapore.
                </p>

                <p>
                  Whether is it diagnosis, loss of hearing or maintenance of
                  hearing aids, The Hearing Centre Singapore provides an array
                  of tailor-made solutions for a better quality of life for you
                  and your loved ones. Our strong team does not rest on laurels,
                  we constantly strive to learn more, improve and thrive to stay
                  ahead of the curve!
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about_img text-center text-lg-start">
                <img src={About2} className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ETrusted_Partnerss">
        <div className="container">
          <h1 className="Heading_text wow  zoomIn animated">
            Our Trusted Partners{" "}
          </h1>
          <ul className="Etrusted_img wow  fadeInRight animated">
            <li>
              {" "}
              <img src={Trusted1} className="img-fluid" alt="Trusted" />
            </li>
            <li>
              {" "}
              <img src={Trusted2} className="img-fluid" alt="Trusted" />
            </li>
            <li>
              {" "}
              <img src={Trusted3} className="img-fluid" alt="Trusted" />
            </li>
            <li>
              {" "}
              <img src={Trusted4} className="img-fluid" alt="Trusted" />
            </li>
          </ul>
        </div>
      </section>
      <Footer />
      </Fragment>
    </>
  );
}
